import { render, staticRenderFns } from "./NavigationErrorView.vue?vue&type=template&id=09b4a356&scoped=true&"
import script from "./NavigationErrorView.vue?vue&type=script&lang=ts&"
export * from "./NavigationErrorView.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationErrorView.vue?vue&type=style&index=0&id=09b4a356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4a356",
  null
  
)

export default component.exports